export default __webpack_public_path__ + "static/media/5453@3x.3700f246.png";